import { useState } from "react";
import { toast } from "sonner";
import { resetPassword } from "./consumerAuth";

const C = { navy: "#0B1E3B", red: "#E01A2E", body: "#F7F5F0", slate: "#5B6B7E", ink: "#1A1E24", green: "#1E9E63" };

export default function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [role, setRole] = useState("consumer");
  const isOps = role === "admin" || role === "client";

  const submit = async () => {
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const res = await resetPassword(token, pw);
      setRole(res?.role || "consumer");
      setDone(true);
      toast.success("Password updated — you can now sign in");
    } catch (e) {
      toast.error("Couldn't reset password", { description: e.response?.data?.detail || "The link may be invalid or expired." });
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(160deg,#0d1826,#0B1E3B 60%,#12263f)`, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Inter', system-ui, sans-serif" }} data-testid="reset-password-page">
      <div style={{ width: 420, maxWidth: "100%", background: C.body, borderRadius: 18, padding: 32, boxShadow: "0 30px 80px rgba(0,0,0,0.45)" }}>
        <div style={{ fontWeight: 900, letterSpacing: "-0.04em", fontSize: 22, color: C.ink, marginBottom: 4 }}>RESQ<span style={{ color: C.red }}>1</span></div>
        {!token ? (
          <div data-testid="reset-no-token" style={{ color: C.slate, fontSize: 14, marginTop: 12 }}>This reset link is missing its token. Please use the link from your email.</div>
        ) : done ? (
          <div data-testid="reset-success" style={{ marginTop: 12 }}>
            <div style={{ color: C.green, fontWeight: 700, fontSize: 16 }}>Password updated</div>
            <p style={{ color: C.slate, fontSize: 14, marginTop: 8 }}>{isOps ? "Sign in to the dispatch console with your new password." : "You can now sign in with your new password."}</p>
            <a href={isOps ? "/login" : "/app"} data-testid="reset-goto-app" style={{ display: "inline-block", marginTop: 14, padding: "12px 22px", background: C.ink, color: "#fff", borderRadius: 999, textDecoration: "none", fontSize: 14, fontWeight: 600 }}>{isOps ? "Go to console sign in →" : "Open the app →"}</a>
          </div>
        ) : (
          <>
            <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 26, fontWeight: 500, color: C.ink, margin: "8px 0 6px" }}>Set a new password</h1>
            <p style={{ color: C.slate, fontSize: 14, marginBottom: 20 }}>Choose a new password for your ResQ1 account.</p>
            <div style={{ display: "grid", gap: 14 }}>
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 8 chars)" data-testid="reset-password-input"
                style={{ width: "100%", padding: "12px 14px", border: "1px solid rgba(26,30,36,0.16)", borderRadius: 8, fontSize: 14, outline: "none" }} />
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm new password" data-testid="reset-password-confirm"
                style={{ width: "100%", padding: "12px 14px", border: "1px solid rgba(26,30,36,0.16)", borderRadius: 8, fontSize: 14, outline: "none" }} />
            </div>
            <button onClick={submit} disabled={busy} data-testid="reset-submit"
              style={{ marginTop: 20, width: "100%", padding: 14, background: C.red, color: "#fff", border: 0, borderRadius: 999, fontSize: 15, fontWeight: 700, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
              {busy ? "Updating…" : "Update password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
